// extracted by mini-css-extract-plugin
module.exports = {"sider":"sider--YrAaK","content":"content--rTWjg","overflowScroll":"overflowScroll--jBqvl"};